import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router'
import { Store } from 'antd/lib/form/interface';
import styles from './AttendanceDetail.module.css';
import { Layout, Typography, Table, Form, Input, Tooltip, Modal, Button, Pagination, Alert } from 'antd';
import { CriteriaForm, Checkbox, AuthButton, AuthButtonAuthorities } from '../../core/CoreForm'
import { Header, ContentEx as Content, FunctionTitle, CommonMessage, FooterButtonArea, Footer } from '../../core/CorePageContents'

import * as Module from '../../../modules/partner/attendance/attendanceModule';
import * as Model from '../../../modules/partner/attendance/attendanceModel';
import { initMessages, setMessages, setModalMessages, message } from '../../../modules/core/commonMessageModule';
import * as formatUtils from '../../../utils/formatUtils';
import * as CONSTANTS from '../../../constants/constants';
import * as validationRules from '../../../validation/coreRules';
import * as messagesUtils from '../../../utils/messagesUtils';
import * as Utils from '../../../utils/utils';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import AuthButtonStyles from '../../core/css/AuthButton.module.css';
import { initApiResult, storedApiResult, setApiResult } from '../../../modules/core/bffApiModule';
import { RightSquareFilled, LeftSquareFilled, ExclamationCircleOutlined, QuestionCircleFilled } from '@ant-design/icons';
import { putLoginUserInfoAlertAsync, setLoginUserInfo, storedLoginUserInfo } from '../../../modules/core/authModule';
import * as constantsUtils from '../../../utils/constantsUtils';


import { AbolishCompanyListButton } from '../../core/parts/AbolishCompanyListButton'
import { MergeCompanyAnnotations } from '../../core/parts/MergeCompanyAnnotations'
import { ForceApprovalAnnotations } from '../../core/parts/ForceApprovalAnnotations'
import { CcusLevelLabel } from '../../core/parts/CcusLevelLabel';

interface titleInterface {
  title: string;
}

export const AttendanceDetail = (props: titleInterface) => {

  const dispatch = useDispatch();
  let dataList = useSelector(Module.storedDetailDataList);
  let allSelect = useSelector(Module.storedAllSelect);
  let criteria = useSelector(Module.storedCriteria);
  let total = useSelector(Module.storedDetailTotal);
  let primeCompanyId = useSelector(Module.storedPrimeCompanyId);
  let primeCompanyName = useSelector(Module.storedPrimeCompanyName);
  let branchName = useSelector(Module.storedBranchName);
  let projectId = useSelector(Module.storedProjectId);
  let projectName = useSelector(Module.storedProjectName);
  let belongCompanyId = useSelector(Module.storedBelongCompanyId);
  let belongCompanyName = useSelector(Module.storedBelongCompanyName);
  let firstPartnerCompanyId = useSelector(Module.storedFirstPartnerCompanyId);
  let existSubmittedChecked = useSelector(Module.storedExistSubmittedChecked);
  let existNotSubmittedChecked = useSelector(Module.storedExistNotSubmittedChecked);
  let modalVisibleState = useSelector(Module.storedModalVisibleState);
  let qualificationModalVisibleState = useSelector(Module.storedQualificationModalVisibleState);
  let info = useSelector(Module.storedSelectedAttendanceInfo);
  let editAvailableFlag = useSelector(Module.storedEditAvailableFlag);
  let existAvailableRow = useSelector(Module.storedExistAvailableRow);
  let loginUserInfo = useSelector(storedLoginUserInfo);
  let isLoading = useSelector(Module.storedLoading);
  let worktimeConfirmModalVisibleState = useSelector(Module.storedWorktimeConfirmModalVisibleState);
  let worktimeConfirmText = useSelector(Module.storedWorktimeConfirmText);
  let worktimeConfirmTextWorker = useSelector(Module.storedWorktimeConfirmTextWorker);
  let worktimeConfirmTextDate = useSelector(Module.storedWorktimeConfirmTextDate);
  let isContainInvalidInOutTime = useSelector(Module.storedIsContainInvalidInOutTime);
  let apiResult = useSelector(storedApiResult);
  let history = useHistory();
  let qualificationList = useSelector(Module.storedQualificationList);
  let existNotSubmitted = useSelector(Module.storedExistNotSubmitted);
  let submitModalDisagreeVisibleState = useSelector(Module.storedSubmitModalDisagreeVisibleState);
  const [form] = Form.useForm();

  useEffect(() => {
    callGetDetailDataListApi();
  },
    [criteria]
  );

  /**
   * 月末の日付の取得
   * @param attendanceYearMonth 
   */
  const getLastDay = (attendanceYearMonth: string) => {
    // 年
    let year = parseInt(attendanceYearMonth.substring(0, 4));

    // 月
    let month = parseInt(attendanceYearMonth.substring(4, 6));

    return new Date(year, month, 0).getDate();
  }

  /**
   * 日毎の勤務実績部分の作成
   * @param attendanceYearMonth 
   */
  const getDaily = (attendanceYearMonth: string) => {
    let daysColumn = [];

    // 年
    let year = parseInt(attendanceYearMonth.substring(0, 4));

    // 月
    let month = parseInt(attendanceYearMonth.substring(4, 6));

    // 月の最終日の取得
    let lastDay = getLastDay(attendanceYearMonth);

    // 曜日文字列定義
    const weekDayChars = ['日', '月', '火', '水', '木', '金', '土']

    for (let i = 1; i <= lastDay; i++) {
      // 日付オブジェクトの作成
      let day = new Date(year, month - 1, i);
      let name = ""

      if (day.getDay() === 0 || day.getDay() === 6) {
        // 土日の場合は背景色をピンクにする
        name = styles.holiday;
      } else {
        name = styles.day;
      }

      daysColumn.push(
        {
          title: i,
          dataIndex: 'day' + i,
          key: 'day' + i,
          className: name,
          align: 'center' as 'center',
          children: [{
            title: weekDayChars[day.getDay()],
            className: name,
            onCell: () => ({
              style: {
                minWidth: '40px'
              }
            }),
            align: 'center' as 'center',
            render: (test: string, row: Model.WorkRecordDetailRow) => {
              if (isRetired(row) && isStatusForceApprovedFromNotSubmitted(row)) {
                return (
                  {
                    props: {
                      colSpan: 0
                    }
                  }
                )
              } else {

                const firstInTime = row.dailyWorkStatusList[i - 1].firstInTime;
                const lastOutTime = row.dailyWorkStatusList[i - 1].lastOutTime;
                const isValid = isValidPeriod(row.dailyWorkStatusList[i - 1].meetQualificationRequirementType);
                const isTimeEmptyOrZero = (time: string) => {
                  return time === "" || time === "0:00" || time === "00:00";
                }
                let workingTime = formatUtils.formatTime(row.dailyWorkStatusList[i - 1].workingTime);

                let className = "";
                let classNameOutside = "";
                let inOutClassName = Utils.isInversionInOutTime(firstInTime, lastOutTime) ? styles.invalidInOutTime :styles.inOutTIme;
                if (isValid) {
                  if (row.dailyWorkStatusList[i - 1].editWorkingTimeFlag) {
                    // 労働時間が編集されている
                    className = styles.diffWorking;
                  } else {
                    className = styles.working;
                  }
                } else {
                  className = styles.invalidQualification;
                  classNameOutside = styles.invalidQualificationOutside;
                  inOutClassName = styles.invalidQualificationInOutTime;
                }

                if (isTimeEmptyOrZero(workingTime)
                  && (Utils.isNullOrEmpty(firstInTime)
                  || Utils.isNullOrEmpty(lastOutTime)
                  || Utils.isInversionInOutTime(firstInTime, lastOutTime))) {
                  // (入退場の少なくとも一方が空 または 入退場時間が逆転している) かつ 労働時間がゼロならば空にする
                  workingTime = "";
                }

                let firstInTimeTag = Utils.isNullOrEmpty(firstInTime) ? <>&nbsp;</> : formatUtils.formatDateToTime(firstInTime);
                let lastOutTimeTag = Utils.isNullOrEmpty(lastOutTime) ? <>&nbsp;</> : formatUtils.formatDateToTime(lastOutTime);
                let workingTimeTag: any = "";
                if (isValid) {
                  if (isNotSubmitted(row) && isEditableWorkTime(primeCompanyId)) {
                    // 未提出かつ編集可設定の場合は編集可能
                    workingTimeTag = <a onClick={() => onClickEdit(row, i - 1)}>{workingTime === "" ? "編集" : workingTime}</a>
                  } else {
                    // 提出済みの場合は編集不可
                    workingTimeTag = workingTime === "" ? <>&nbsp;</> : workingTime;
                  }
                } else {
                  // 有効期間外であれば労働時間を「対象外」を表示
                  workingTimeTag = "対象外";
                }

                return (
                  <>
                    <div className={inOutClassName}>{firstInTimeTag}</div>
                    <div className={inOutClassName}>{lastOutTimeTag}</div>
                    <div className={className}><span className={classNameOutside}>{workingTimeTag}</span></div>
                  </>
                )
              }
            }
          }]
        }
      );
    }
    return daysColumn;
  }

  /** 有効期間内かどうか */
  const isValidPeriod = (type: string) => {
    return type !== CONSTANTS.QUALIFICATION_REQUIREMENT_TYPE.OUTSIDE_VALID_PERIOD.code;
  }

  /** 未提出（差戻含む）かどうかチェック */
  const isNotSubmitted = (row: Model.WorkRecordDetailRow) => {
    return isStatusNotSubmitted(row) || isStatusRemand(row) || row.approvalStatus === "";
  }

  /** 外部承認かどうかチェック */
  const isStatusForceApproved = (row: Model.WorkRecordDetailRow): boolean => {
    return row.forceApprovalFlag === CONSTANTS.FORCE_APPROVAL_FLAG_ON;
  }

  /** 承認済かどうかチェック */
  const isStatusApproved = (row: Model.WorkRecordDetailRow): boolean => {
    return row.forceApprovalFlag === CONSTANTS.FORCE_APPROVAL_FLAG_OFF && row.approvalStatus === CONSTANTS.ATTENDANCE_STATUS_APPROVED;
  }

  /** 差戻かどうかチェック */
  const isStatusRemand = (row: Model.WorkRecordDetailRow): boolean => {
    return row.forceApprovalFlag === CONSTANTS.FORCE_APPROVAL_FLAG_OFF && row.approvalStatus === CONSTANTS.ATTENDANCE_STATUS_REMAND;
  }

  /** 未提出かどうかチェック */
  const isStatusNotSubmitted = (row: Model.WorkRecordDetailRow): boolean => {
    return row.forceApprovalFlag === CONSTANTS.FORCE_APPROVAL_FLAG_OFF && row.approvalStatus === CONSTANTS.ATTENDANCE_STATUS_NOT_SUBMITTED;
  }

  /** 労働時間が自動入力されるかどうか */
  const isCalcWorkTime = (primeCompanyId: string) => {
    return !loginUserInfo.calcWorkTimeNotUsePrimeCompanyIdList.includes(primeCompanyId)
  }

  /** 労働時間が編集可能かどうか */
  const isEditableWorkTime = (primeCompanyId: string) => {
    return !loginUserInfo.workTimeNotEditablePrimeCompanyIdList.includes(primeCompanyId)
  }

  /** 一次協力会社のみ提出可能かどうか */
  const isSubmitLevelOnlyFirst = (primeCompanyId: string) => {
    return loginUserInfo.submitLevelOnlyFirstPrimeCompanyIdList.includes(primeCompanyId)
  }

  /** 所属企業が提出可能な協力会社かどうか */
  const canSubmitLoginCompany = () => {
    if (isSubmitLevelOnlyFirst(primeCompanyId)) {
      // 一次協力会社のみの場合、所属企業が一致する場合（自社が一次協力会社）、true
      return firstPartnerCompanyId === loginUserInfo.belongCompanyId;
    } else {
      // 全次数（制限なし）の場合、常にtrue
      return true;
    }
  }

  /**
   * 全選択チェックボックスを表示するか
   * 勤怠提出者権限を保持、提出期限を過ぎていない、利用可能な勤怠（承認済以外）を表示している場合、表示
   */
  const isDisplayCheckBox = () => {
    if (loginUserInfo.authorityInfo.partnerAttendanceSubmitAuth === "0") {
      // 勤怠提出者権限を保持していない
      return false;
    }

    if (!canSubmitLoginCompany()) {
      // 提出権限を保持していない
      return false;
    }

    // 処理できる行がある場合に表示
    return existAvailableRow;
  }

  /** 外部承認（未提出、差戻から承認）かどうかチェック */
  const isStatusForceApprovedFromNotSubmitted = (row: Model.WorkRecordDetailRow): boolean => {
    return row.forceApprovalFlag === CONSTANTS.FORCE_APPROVAL_FLAG_ON && (row.approvalStatus === CONSTANTS.ATTENDANCE_STATUS_NOT_SUBMITTED || row.approvalStatus === CONSTANTS.ATTENDANCE_STATUS_REMAND);
  }

  /** 退職済かどうかチェック */
  const isRetired = (row: Model.WorkRecordDetailRow): boolean => {
    return row.retiredFlag === CONSTANTS.RETIRED_FLAG.RETIRED;
  }

  /** 編集禁止のアラートを表示するかどうか */
  const isDisplayNotEditable = (primeCompanyId: string): boolean => {
    // 労働時間が編集不可 かつ 勤怠提出者権限を持っている かつ セッションの「編集禁止のアラートを非表示にする元請企業IDリスト」に元請企業IDがない場合
    return (
      !isEditableWorkTime(primeCompanyId)
      && loginUserInfo.authorityInfo.partnerAttendanceSubmitAuth === "1"
      && !loginUserInfo.hiddenAlertPrimeCompanyIdList[CONSTANTS.HIDDEN_ALERT.NotEditable].includes(primeCompanyId)
    );
  }

  /** ログインユーザが企業担当者かどうか */
  const isCompanyStaff = (): boolean => {
    return CONSTANTS.MANAGER_FLAG.COMPANY_STAFF == loginUserInfo.managerFlag;
  }

  /** ログインユーザの所属企業と画面に表示している所属企業が一致しているかどうか */
  const isLoginUserBelongCompanyEqualDisplayBelongCompany = (): boolean => {
    return loginUserInfo.belongCompanyId == belongCompanyId;
  }

  /**
   * CriteriaをStoreに保持
   * @param keyValueList 
   */
  const criteriaDataTransfer = (keyValueList: Array<{ key: string, value: any }>) => {
    let newCriteria: Model.WorkRecordDetailCriteria = {
      attendanceYearMonth: criteria.attendanceYearMonth,
      primeCertificationNo: criteria.primeCertificationNo,
      workerLastName: criteria.workerLastName,
      workerFirstName: criteria.workerFirstName,
      workerLastNameKana: criteria.workerLastNameKana,
      workerFirstNameKana: criteria.workerFirstNameKana,
      firstPartnerCompanyName: criteria.firstPartnerCompanyName,
      firstPartnerCompanyNameKana: criteria.firstPartnerCompanyNameKana,
      fromTopHierarchyLevel: criteria.fromTopHierarchyLevel,
      toTopHierarchyLevel: criteria.toTopHierarchyLevel,
      offset: criteria.offset,
      limit: criteria.limit,
      approved: criteria.approved,
      submitted: criteria.submitted,
      remand: criteria.remand,
      noSubmitted: criteria.noSubmitted,
      hasInOutWorkTimeCheck: criteria.hasInOutWorkTimeCheck
    }
    keyValueList.forEach((rec: { key: string, value: any }) => {
      newCriteria[rec.key] = rec.value;
    })
    dispatch(Module.setCriteria(newCriteria));
  }

  // 検索が正常終了した時の処理
  if (CONSTANTS.API_STATUS_INITIAL !== apiResult.status
    && "" === apiResult.errorCode
    && CONSTANTS.REQUEST_METHOD_GET === apiResult.requestMethod
    && CONSTANTS.URL_ATTENDANCE_PARTNER_DETAIL === apiResult.url) {

    // 2ページ目以降を表示していて、総件数はあるが、表示するデータが空の場合、再取得する
    if (criteria.offset > 0 && total > 0 && dataList.length === 0) {

      // API結果情報を初期化します。
      dispatch(initApiResult());

      // 最終ページを取得する（基本的には一つ前のページ）
      const newOffset = Utils.calcLastPageOffset(total, criteria.limit);
      criteriaDataTransfer([
        { key: "offset", value: newOffset }
      ]);
    }
  }

  if (window.location.search !== ""
    && criteria.attendanceYearMonth === ""
    && projectId === ""
    && belongCompanyId === ""
    && firstPartnerCompanyId === "") {
    let urlParamStr = window.location.search.substring(1);

    let workAttendanceYearMonth = "";
    let workProjectId = "";
    let workBelongCompanyId = "";
    let workFirstPartnerCompanyId = "";

    urlParamStr.split('&').forEach(param => {
      const temp = param.split('=');

      if (temp[0] === "attendanceYearMonth") {
        workAttendanceYearMonth = temp[1];
      }
      if (temp[0] === "projectId") {
        workProjectId = temp[1];
      }
      if (temp[0] === "belongCompanyId") {
        workBelongCompanyId = temp[1];
      }
      if (temp[0] === "firstPartnerCompanyId") {
        workFirstPartnerCompanyId = temp[1];
      }
    });

    if (Utils.isNullOrEmpty(workAttendanceYearMonth) || Utils.isNullOrEmpty(workProjectId) || Utils.isNullOrEmpty(workBelongCompanyId) || Utils.isNullOrEmpty(workFirstPartnerCompanyId)) {
      // 1つでも設定されていないパラメータが存在する場合
      history.push(CONSTANTS.PATH_PARTNER_ATTENDANCE_SUMMARY);
    } else {
      // 全てのパラメータに設定されている場合のみ以下の処理を行う（パラメータによっては空のときエラーが起きるため）
      let urlParamValues: Model.UrlParameter = {
        attendanceYearMonth: workAttendanceYearMonth
        , projectId: workProjectId
        , belongCompanyId: workBelongCompanyId
        , firstPartnerCompanyId: workFirstPartnerCompanyId
      }
  
      dispatch(Module.setUrlParameterValue(urlParamValues));
    }
  } else if (window.location.search === ""
    && criteria.attendanceYearMonth === ""
    && projectId === ""
    && belongCompanyId === ""
    && firstPartnerCompanyId === "") {
    history.push(CONSTANTS.PATH_PARTNER_ATTENDANCE_SUMMARY);
  }

  if ("" === apiResult.errorCode
    && CONSTANTS.REQUEST_METHOD_GET === apiResult.requestMethod
    && CONSTANTS.URL_ATTENDANCE_PARTNER_DETAIL === apiResult.url
    && editAvailableFlag === CONSTANTS.EDIT_AVAILABLE_FLAG_NOT_AVAILABLE) {
    if (existNotSubmitted) {
      // 編集不可の場合
      const setMessage: message = {
        message: messagesUtils.getMessage("ERROR_DEADLINE_PASSED_PARTNER")
        , messageType: CONSTANTS.MESSAGE_TYPE_ERROR
      }
      dispatch(setMessages([setMessage]));
    }
  }

  // 有効期限を描画します。
  const renderDeadlineTerm = (value: string, row: Model.QualificationRow) => {
    return {
      children: (
        formatUtils.formatDuration(row.deadlineStartDate, row.deadlineEndDate)
      )
    }
  };

  /**
   * 資格一覧ダイアログの表示
   */
  const qualificationDialogColumns = [
    {
      title: '資格名'
      , width: '200px'
      , dataIndex: 'originalQualificationName'
      , align: 'left' as 'left'
      , render: (value: any, row: Model.QualificationRow) => {
        return (
          <>
            <span>{ row.originalQualificationName }</span>
          </>
        )
      }
    },
    {
      title: '対象次数'
      , width: '80px'
      , dataIndex: 'levelRangeTo'
      , align: 'left' as 'left'
      , render: (value: string, row: Model.QualificationRow) => {
        return (
          <>
            <span>{ constantsUtils.getLabelOf(CONSTANTS.LEVEL_RANGE_TO, String(row.levelRangeTo)) }</span>
          </>
        )
      }
    },
    {
      title: '対象プロジェクト'
      , width: '220px'
      , dataIndex: 'certificationProject'
      , align: 'left' as 'left'
      , render: (value: string, row: Model.QualificationRow) => {
        return (
          renderProjectName(row.certificationProjectName, row)
        )
      }
    },
    {
      title: '認定日'
      , width: '100px'
      , dataIndex: 'certificationDate'
      , align: 'left' as 'left'
      , render: (value: string, row: Model.QualificationRow) => {
        return (
          formatUtils.formatDateSlash(row.certificationDate)
        )
      }
    },
    {
      title: '有効期間'
      , width: '200px'
      , dataIndex: 'deadlineTerm'
      , align: 'left' as 'left'
      , render: renderDeadlineTerm
    }
  ];

  /** 外部承認？ツールチップ */
  const ForceApprovalTooltip = (row: Model.WorkRecordDetailRow) => {
    return <ForceApprovalAnnotations isStatusForceApproved={isStatusForceApproved(row)} />
  }

  /** 技能レベルの整形 */
  const CcusLevel = (row: Model.WorkRecordDetailRow) => {
    return <CcusLevelLabel ccusLevel={row.ccusLevel} ccusErrorFlag={row.ccusErrorFlag} />
  };

  /** 一覧部 */
  let columns = [
    {
      title: (
        <>
          <span>選択</span><br />
          <Checkbox
            className={styles.checkBox}
            checked={allSelect}
            onChange={(e: any) => dispatch(Module.onChangeAllSelect(e))}
            style={{ display: `${!isDisplayCheckBox() ? "none" : "inline"}` }}
          >
          </Checkbox>
        </>
      ),
      dataIndex: 'selectFlag',
      key: 'selectFlag',
      className: styles.select,
      align: 'center' as 'center',
      render: (text: string, row: Model.WorkRecordDetailRow) => {
        if (loginUserInfo.authorityInfo.partnerAttendanceSubmitAuth === "0") {
          // 勤怠提出者権限を保持していない場合、表示しない
          return <></>
        } else if (!canSubmitLoginCompany()) {
          // 勤怠提出権限を保持していない場合、表示しない
          return <></>
        } else if (editAvailableFlag === CONSTANTS.EDIT_AVAILABLE_FLAG_NOT_AVAILABLE) {
          // 提出期限を過ぎている場合、表示しない
          return <></>
        } else if (isNotSubmitted(row) && row.hasInOutWorkTime !== CONSTANTS.HAS_IN_OUT_WORK_TIME.HAVING) {
          // 「未提出」「差戻」で入退場／労働時間記録のいずれもない場合、表示しない
          return <></>
        } else if (!isStatusApproved(row) && !isStatusForceApproved(row)) {
          // 「承認済」「外部承認」以外の場合、表示
          return (
            <Checkbox
              checked={row.selectFlag}
              onChange={(e) => onChangeCheck(e, row)}
            >
            </Checkbox>
          )
        } else {
          return <></>
        }
      }
    },
    {
      title: '状態',
      className: styles.status,
      align: 'center' as 'center',
      render: (text: string, row: Model.WorkRecordDetailRow) => {
        let label = "";
        if (isStatusForceApproved(row)) {
          label = "外部承認";
        } else {
          switch (row.approvalStatus) {
            case CONSTANTS.ATTENDANCE_STATUS_APPROVED:
              label = "承認済";
              break;
            case CONSTANTS.ATTENDANCE_STATUS_CONFIRMED:
              label = "確認済";
              break;
            case CONSTANTS.ATTENDANCE_STATUS_UNAPPROVED:
              label = "提出済";
              break;
            case CONSTANTS.ATTENDANCE_STATUS_REMAND:
              label = "差戻";
              break;
            case CONSTANTS.ATTENDANCE_STATUS_NOT_SUBMITTED:
              label = "未提出";
              break;
          }
        }

        return (
          <>
            <span>{label}</span>
            {ForceApprovalTooltip(row)}
            <AbolishCompanyListButton historyId={row.workRecordSubmissionHistoryId} abolishCompanyFlag={row.abolishCompanyFlag} />
          </>)
      }

    },
    {
      title: (
        <>
          <span>元請認定番号</span><br />
          <span>氏名</span><br />
          <span>技能レベル</span><br />
        </>
      ),
      className: styles.worker,
      align: 'center' as 'center',
      render: (text: string, row: Model.WorkRecordDetailRow) => {
        return (
          <>
            <div className={styles.flexCell}>
              <div className={styles.contentLeft}>
                <span>{row.primeCertificationNo}</span><br />
                {isRetired(row) ? <span className={styles.retiredWorker}>《退職済み》</span> : <></>}
                <span>{row.name}</span><br />
                {CcusLevel(row)}<br />
              </div>
              <Button
                name={"保持資格"}
                onClick={() => onClickQualification(row)}
                className={styles.materialSearchButton}
              >
                <i className="material-icons">search</i>
              </Button>
            </div>
          </>
        )
      }
    },
    {
      title: '一次協力会社',
      className: styles.firstPartner,
      align: 'center' as 'center',
      width: '160px',
      render: (text: string, row: Model.WorkRecordDetailRow) => {
        return (
          <>
            <div className={styles.columnAlignLeft}>{row.firstPartnerCompanyName}</div>
          </>
        )
      }
    },
    {
      title: '作業次数',
      className: styles.topHierarchyLevel,
      align: 'center' as 'center',
      render: (text: string, row: Model.WorkRecordDetailRow) => {
        return (
          <>
            <div className={styles.contentRight}>
              <span>{row.topHierarchyLevel}</span>
            </div>
          </>
        )
      }
    },
    {
      title: '項目',
      className: styles.item,
      align: 'center' as 'center',
      render: (text: string, row: Model.WorkRecordDetailRow) => {
        if (isRetired(row) && isStatusForceApprovedFromNotSubmitted(row)) {
          return (
            {
              props: {
                colSpan: getLastDay(criteria.attendanceYearMonth) + 2,
                align: "center",
              },
              children: (<div>未提出の勤怠を外部承認しました。</div>)
            }
          )
        } else {
          return {
            children: (<>
              <div className={styles.totalDays}>入退場履歴</div>
              <div className={styles.totalWorking}>労働時間</div>
            </>)
          }
        }
      }
    },
    {
      title: (
        <>
          <span>日数</span><br /><br />
          <span>合計</span>
        </>
      ),
      className: styles.total,
      align: 'center' as 'center',
      render: (text: string, row: Model.WorkRecordDetailRow) => {
        if (isRetired(row) && isStatusForceApprovedFromNotSubmitted(row)) {
          return (
            {
              props: {
                colSpan: 0
              }
            }
          )
        } else {
          return (
            <>
              <div className={styles.totalDaysValue}>{row.days}</div>
              <div className={styles.totalWorkingValue}>{row.totalWorkingTime}</div>
            </>
          )
        }
      }
    },
    {
      title: '労働者出勤実績',
      className: styles.workingRecordTitle,
      align: 'center' as 'center',
      children: getDaily(criteria.attendanceYearMonth)
    }
  ];

  const callGetDetailDataListApi = () => {
    // パラメータが存在しない場合はデータを取得しない
    if (criteria.attendanceYearMonth === ""
      || projectId === ""
      || belongCompanyId === "") {
      return;
    }

    let statusList: Array<string> = [];
    if (criteria.approved) {
      statusList.push(CONSTANTS.ATTENDANCE_STATUS_APPROVED);
    }
    if (criteria.submitted) {
      statusList.push(CONSTANTS.ATTENDANCE_STATUS_CONFIRMED);
      statusList.push(CONSTANTS.ATTENDANCE_STATUS_UNAPPROVED);
    }
    if (criteria.remand) {
      statusList.push(CONSTANTS.ATTENDANCE_STATUS_REMAND);
    }
    if (criteria.noSubmitted) {
      statusList.push(CONSTANTS.ATTENDANCE_STATUS_NOT_SUBMITTED);
    }
    let params: Model.getDetailDataList.Request = {
      attendanceYearMonth: criteria.attendanceYearMonth,
      projectId: projectId,
      belongCompanyId: belongCompanyId,
      firstPartnerCompanyId: firstPartnerCompanyId,
      primeCertificationNo: criteria.primeCertificationNo,
      lastName: criteria.workerLastName,
      firstName: criteria.workerFirstName,
      lastNameKana: criteria.workerLastNameKana,
      firstNameKana: criteria.workerFirstNameKana,
      firstPartnerCompanyName: criteria.firstPartnerCompanyName,
      firstPartnerCompanyNameKana: criteria.firstPartnerCompanyNameKana,
      fromTopHierarchyLevel: criteria.fromTopHierarchyLevel,
      toTopHierarchyLevel: criteria.toTopHierarchyLevel,
      status: statusList.toString(),
      hasInOutWorkTimeCheck: criteria.hasInOutWorkTimeCheck === true ? CONSTANTS.HAS_IN_OUT_WORK_TIME_CHECK.ON : CONSTANTS.HAS_IN_OUT_WORK_TIME_CHECK.OFF,
      offset: criteria.offset,
      limit: criteria.hasInOutWorkTimeCheck === true ? 0 : criteria.limit
    }
    dispatch(Module.getDetailDataListAsync(params));
  }

  if (CONSTANTS.REQUEST_METHOD_PUT === apiResult.requestMethod
    && CONSTANTS.URL_ATTENDANCE_PARTNER_DAILY === apiResult.url) {

    dispatch(Module.setLoading(false));

    if (CONSTANTS.API_STATUS_INITIAL !== apiResult.status
      && "" === apiResult.errorCode) {
      const setMessage: message = {
        message: messagesUtils.getMessage("SUCCESS_ATTENDANCE_PROCESS", ["労働時間の編集"])
        , messageType: CONSTANTS.MESSAGE_TYPE_SUCCESS
      }
      dispatch(setMessages([setMessage]));

      // 労働時間編集ダイアログを閉じる
      dispatch(Module.reflectModalState(false));

      dispatch(initApiResult());

      callGetDetailDataListApi();
    }

  } else if (CONSTANTS.API_STATUS_INITIAL !== apiResult.status
    && "" === apiResult.errorCode
    && CONSTANTS.REQUEST_METHOD_PUT === apiResult.requestMethod
    && CONSTANTS.URL_ATTENDANCE_CMN_STATUS === apiResult.url) {

      const messageText = messagesUtils.getMessageTextFromSession();
      const messageType = messagesUtils.getMessageTypeFromSession() || CONSTANTS.MESSAGE_TYPE_SUCCESS;
      if (messageText !== null) {
        const setMessage: message = {
          message: messageText
          , messageType: messageType
        }
      dispatch(setMessages([setMessage]));

      messagesUtils.clearSessionMessage();

      // 提出および提出取消処理完了の旨を伝えるダイアログを表示
      window.alert(messageText);
    }

    // API結果情報を初期化します。
    dispatch(initApiResult());

    // 提出、提出取消処理後
    callGetDetailDataListApi();
  }

  /**
   * 勤怠年月変更日イベント
   * @param addValue 
   */
  const onChangeMonth = (addValue: number) => {
    // API結果情報を初期化します。
    dispatch(initApiResult());
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let year = parseInt(criteria.attendanceYearMonth.substring(0, 4));
    let month = parseInt(criteria.attendanceYearMonth.substring(4, 6));

    // 変更後の日付インスタンスの作成
    let newDate = new Date(year, (month - 1) + addValue, 1);

    year = newDate.getFullYear();
    month = newDate.getMonth() + 1;

    criteriaDataTransfer([
      { key: "attendanceYearMonth", value: year.toString() + ("0" + month).slice(-2) }
    ]);
  }

  const searchDataList = (value: Store) => {
    // API結果情報を初期化します。
    dispatch(initApiResult());
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    criteriaDataTransfer([
      { key: "primeCertificationNo", value: value.primeCertificationNo }
      , { key: "firstPartnerCompanyName", value: value.firstPartnerCompanyName }
      , { key: "firstPartnerCompanyNameKana", value: value.firstPartnerCompanyNameKana }
      , { key: "workerLastName", value: value.workerLastName }
      , { key: "workerFirstName", value: value.workerFirstName }
      , { key: "workerLastNameKana", value: value.workerLastNameKana }
      , { key: "workerFirstNameKana", value: value.workerFirstNameKana }
      , { key: "fromTopHierarchyLevel", value: value.fromTopHierarchyLevel }
      , { key: "toTopHierarchyLevel", value: value.toTopHierarchyLevel }
      , { key: "offset", value: 0 }
      , { key: "approved", value: value.approved }
      , { key: "submitted", value: value.submitted }
      , { key: "remand", value: value.remand }
      , { key: "noSubmitted", value: value.noSubmitted }
      , { key: "hasInOutWorkTimeCheck", value: value.hasInOutWorkTimeCheck }
    ]);
  }

  /**
   * チェックボックス変更時イベント
   * @param e 
   * @param row 
   */
  const onChangeCheck = (e: CheckboxChangeEvent, row: Model.WorkRecordDetailRow) => {
    let transfer: Module.changeCheckTransfer = {
      targetDataRow: row,
      value: e.target.checked
    }

    dispatch(Module.onChangeRowSelect(transfer));
  }

  /**
   * ページ変更時イベント（ページ、表示件数）
   * @param pagination
   * @param filters
   */
  const handlePaginationChange = (page: any, pageSize: any) => {
    // API結果情報を初期化します。
    dispatch(initApiResult());
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let offsetReset: boolean = false;

    if (criteria.limit !== pageSize) {
      offsetReset = true;
    }

    criteriaDataTransfer([
      { key: "limit", value: pageSize }
      , { key: "offset", value: offsetReset ? 0 : (page - 1) * pageSize }
    ])
  }

  /**
   * 戻るボタン押下
   */
  const onClickBack = () => {
    // API結果情報を初期化します。
    dispatch(initApiResult());
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    history.push(CONSTANTS.PATH_PARTNER_ATTENDANCE_SUMMARY);
  }

  /**
   * 各種処理ボタン押下
   * @param processType 処理種別 
   */
  const onClickProcess = async (processType: CONSTANTS.ATTENDANCE_PROCESS_TYPE) => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let args: string[] = [];

    // 処理タイプ毎にメッセージを取得
    switch (processType) {
      case CONSTANTS.ATTENDANCE_PROCESS_TYPE.SUBMIT:
        args.push("提出");
        args.push("未提出または差戻")
        break;
      case CONSTANTS.ATTENDANCE_PROCESS_TYPE.SUBMIT_CANCEL:
        args.push("提出取消");
        args.push("提出済");
        break;
      default:
        return;
    }

    if (existSubmittedChecked && existNotSubmittedChecked) {
      // 未提出の勤怠と、提出済みの勤怠が混在して選択されている
      const setMessage: message = {
        message: messagesUtils.getMessage("ERROR_ATTENDANCE_PROCESS", args)
        , messageType: CONSTANTS.MESSAGE_TYPE_ERROR
      }
      dispatch(setMessages([setMessage]));
      return;
    }

    if (processType == CONSTANTS.ATTENDANCE_PROCESS_TYPE.SUBMIT_CANCEL
      && dataList.find(d => d.selectFlag && isRetired(d))) {
      // 退職済み作業員の提出取消時の確認ダイアログの表示
      if (!window.confirm(messagesUtils.getMessage("CONFIRM_ATTENDANCE_PROCESS", [args[0]])
        + "\r\n"
        + messagesUtils.getMessage("CONFIRM_ATTENDANCE_PROCESS_SUBMIT_CANCEL", [args[0]]))
      ) {
        return;
      }
    } else {
      // 確認ダイアログの表示
      if (processType == CONSTANTS.ATTENDANCE_PROCESS_TYPE.SUBMIT) {
        // NowLoading表示
        dispatch(initApiResult());
        let params = {
          projectId: projectId,
          belongCompanyId: belongCompanyId,
          workerIdList: dataList.filter(d => d.selectFlag).map(d => d.workerId)
        }
        // GS約款同意状況を取得
        let state = await dispatch(Module.getMutualAidTermsAgreeAsync(params)) as any;
        // GS約款未同意の場合、約款同意ダイアログを表示して終了
        if (state != CONSTANTS.MUTUAL_AID_AGREEMENT_STATE_TYPE.AGREE) {
          dispatch(Module.reflectSubmitModalDisagreeVisibleState(true));
          return;
        }
        // 提出の場合
        if (!window.confirm(messagesUtils.getMessage("CONFIRM_ATTENDANCE_PROCESS_SUBMIT"))) {
          return;
        }
      } else {
        // 提出取消の場合
        if (!window.confirm(messagesUtils.getMessage("CONFIRM_ATTENDANCE_PROCESS", [args[0]]))) {
          return;
        }
      }
    }

    // 勤怠提出の場合に「入退場時間のどちらかがあるのに労働時間が0時間」となっている勤怠がある場合は確認ダイアログを出す
    if (processType === CONSTANTS.ATTENDANCE_PROCESS_TYPE.SUBMIT) {
      const isTimeZero = (time: string) => {
        return time === "0:00" || time === "00:00" || time === "";
      }
      
      // 確認ダイアログ用の「勤怠がおかしい作業員名とその日付」を抽出する
      let warningTextWorkerList: string[] = [];
      let warningTextDateList: string[] = [];

      for (const d of dataList) {
        if (d.selectFlag) {
          let alertDayList: number[] = [];
          for (let i = 0; i < d.dailyWorkStatusList.length; i++) {
            const ws = d.dailyWorkStatusList[i];
            if ((!Utils.isNullOrEmpty(ws.firstInTime) || !Utils.isNullOrEmpty(ws.lastOutTime)) && isTimeZero(ws.workingTime)) {
              alertDayList.push(i + 1);
            }
          }
          if (alertDayList.length > 0) {
            warningTextWorkerList.push(d.name);
            warningTextDateList.push(parseInt(criteria.attendanceYearMonth.substring(4, 6)) + '月' + alertDayList.map(d => `${d}日`).join("・"));
          }
        }
      }

      // 確認ダイアログ用のメッセージが存在する（おかしい勤怠が存在する）場合は確認ダイアログを表示
      if (warningTextWorkerList.length > 0) {
        let confirmTxt = "以下、労働時間が0時間の日が含まれている作業員とその日付です。\r\nこのまま";
        confirmTxt += `${parseInt(criteria.attendanceYearMonth.substring(0, 4))}年${parseInt(criteria.attendanceYearMonth.substring(4, 6))}月分の勤怠を提出してもよろしいですか。\r\n`;
        dispatch(Module.setWorktimeConfirmText(confirmTxt));
        dispatch(Module.setWorktimeConfirmTextWorker(warningTextWorkerList));
        dispatch(Module.setWorktimeConfirmTextDate(warningTextDateList));
        dispatch(Module.reflectWorktimeConfirmModalVisibleState(true));
        return;
      }
    }

    submitAttendance(processType);
  }

  const submitAttendance = (processType: CONSTANTS.ATTENDANCE_PROCESS_TYPE) => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    let args = [];
    // 処理タイプ毎にメッセージを取得
    switch (processType) {
      case CONSTANTS.ATTENDANCE_PROCESS_TYPE.SUBMIT:
        args.push("提出");
        args.push("未提出または差戻")
        break;
      case CONSTANTS.ATTENDANCE_PROCESS_TYPE.SUBMIT_CANCEL:
        args.push("提出取消");
        args.push("提出済");
        break;
      default:
        return;
    }

    // API結果情報を初期化します。
    dispatch(initApiResult());

    // リクエストデータの作成
    let destList: Array<Model.putStatus.Dest> = [];

    dataList.forEach((data: Model.WorkRecordDetailRow) => {
      if (data.approvalStatus !== CONSTANTS.ATTENDANCE_STATUS_APPROVED) {
        if (data.selectFlag) {
          let dest: Model.putStatus.Dest = {
            workRecordSubmissionHistoryId: data.workRecordSubmissionHistoryId,
            attendanceYearMonth: criteria.attendanceYearMonth,
            belongCompanyId: belongCompanyId,
            workerId: data.workerId,
            projectId: projectId,
            firstCompanyId: data.firstPartnerCompanyId,
            ccusDbConsentFlag: data.ccusDbConsentFlag,
            updateDatetime: data.updateDatetime
          }

          destList.push(dest);
        }
      }
    });

    // メッセージをセッションストレージに保管
    let message = messagesUtils.getMessage("SUCCESS_ATTENDANCE_PROCESS", [args[0]]);
    messagesUtils.setMessageInSession(message, CONSTANTS.MESSAGE_TYPE_SUCCESS);

    let putData: Model.putStatus.Request = {
      processType: processType,
      destList: destList
    }

    dispatch(Module.putAttendanceStatusAsync(putData));
  }

  /**
   * 編集/労働時間リンク押下時
   * @param row 
   * @param index 
   */
  const onClickEdit = (row: Model.WorkRecordDetailRow, index: number) => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // 労働時間をフォームに設定
    form.setFieldsValue({ workingTime: row.dailyWorkStatusList[index].workingTime });

    // 選択された勤怠年月日の情報をstateに保存
    let attendanceInfo: Model.SelectedAttendanceInfo = {
      workRecordSubmissionHistoryId: row.workRecordSubmissionHistoryId
      , primeCompanyId: primeCompanyId
      , belongCompanyId: belongCompanyId
      , workerId: row.workerId
      , projectId: projectId
      , firstPartnerCompanyId: row.firstPartnerCompanyId
      , dailyWorkStatus: row.dailyWorkStatusList[index]
    }
    dispatch(Module.setModalState(attendanceInfo));
    // 労働時間編集ダイアログの表示
    dispatch(Module.reflectModalState(true));
  }

  /**
   * 労働時間入力テキストボックスのフォーカスアウト時
   * @param value 
   */
  const onBlurWorkingTime = (value: string) => {
    let inputValue = value;
    // 入力値が半角数字か半角「:」以外が含まれる場合はフォーマット処理を行わない
    if (!(/^[0-9:]*$/.test(inputValue))) {
      return;
    }
    let regexNumOnly12 = RegExp('^([0-9]{1,2})$');
    let regexNumOnly34 = RegExp('^([0-9]{1,2})([0-9]{2})$');
    let regex1colon = RegExp('^([0-9]{1,2}):([0-9]{1,2})$');

    let formatVal = "";
    if (regexNumOnly12.test(value)) {
      let mch = regexNumOnly12.exec(value);
      if (mch !== null) {
        formatVal = ("0" + mch[1]).slice(-2) + ":00";
      }
    } else if (regexNumOnly34.test(value)) {
      let mch = regexNumOnly34.exec(value);
      if (mch !== null) {
        formatVal = ("0" + mch[1]).slice(-2) + ":" + mch[2];
      }
    } else if (regex1colon.test(value)) {
      let mch = regex1colon.exec(value);
      if (mch !== null) {
        formatVal = ("0" + mch[1]).slice(-2) + ":" + ("0" + mch[2]).slice(-2);
      }
    }

    form.setFieldsValue({ workingTime: formatVal });
  }

  /**
   * Enterキー押下時
   */
  const onPressEnter = () => {
    let value = form.getFieldValue('workingTime');
    onBlurWorkingTime(value);
  }

  /**
   * 確定ボタン押下
   */
  // 共通メッセージ情報を初期化します。
  const onClickDecision = () => {
    dispatch(initMessages());

    // 入力された労働時間の正当性のチェック
    let value = form.getFieldValue('workingTime');

    let regexTime = RegExp("^(2[0-3]|[0-1][0-9]):[0-5][0-9]$");
    
    // 入力値が半角数字か半角「:」以外が含まれる場合は、エラーメッセージを表示
    if (!(/^[0-9:]*$/.test(value))) {
      const setMessage: message = {
        message: messagesUtils.getMessage("ERROR_VALIDATION")
        , messageType: CONSTANTS.MESSAGE_TYPE_ERROR
      }
      dispatch(setModalMessages([setMessage]));
      return;
    }

    if (value !== "" && !regexTime.test(value)) {
      // 入力された労働時間が時間として正しい値ではない
      const setMessage: message = {
        message: messagesUtils.getMessage("ERROR_INVALID_WORKING_TIME")
        , messageType: CONSTANTS.MESSAGE_TYPE_ERROR
      }
      dispatch(setModalMessages([setMessage]));
      return;
    }

    // API結果情報を初期化します。
    dispatch(initApiResult());

    // リクエストデータの作成
    let putData: Model.editWorkingTime.Request = {
      workRecordSubmissionHistoryId: info.workRecordSubmissionHistoryId
      , primeCompanyId: info.primeCompanyId
      , belongCompanyId: info.belongCompanyId
      , workerId: info.workerId
      , projectId: info.projectId
      , firstPartnerCompanyId: info.firstPartnerCompanyId
      , yearMonth: formatUtils.formatDateToYearMonth(info.dailyWorkStatus.date)
      , day: formatUtils.formatDateToDay(info.dailyWorkStatus.date)
      , workingTime: value === "" ? null : value
      , updateDatetime: info.dailyWorkStatus.updateDatetime
    }

    dispatch(Module.setLoading(true));
    dispatch(Module.putEditAttendanceAsync(putData));
  }

  /**
   * キャンセルボタン押下
   */
  const onClickCancel = () => {
    // ステータスを初期化すると元の画面が「Now Loading」になってしまうので、ステータス以外を初期化
    dispatch(setApiResult({ status: apiResult.status, errorCode: "", requestMethod: "", url: "" }));
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // 労働時間編集ダイアログを閉じる
    dispatch(Module.reflectModalState(false));
  }

  /**
   * 資格一覧ダイアログの閉じるボタン押下
   */
  const onClickQualificationCancel = () => {
    // ステータスを初期化すると元の画面が「Now Loading」になってしまうので、ステータス以外を初期化
    dispatch(setApiResult({ status: apiResult.status, errorCode: "", requestMethod: "", url: "" }));
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // 資格一覧ダイアログを閉じる
    dispatch(Module.reflectQualificationModalState(false));
  }

  /**
   * 労働時間の確認ダイアログのキャンセルボタン押下
   */
  const onClickWorktimeConfirmCancel = () => {
    dispatch(Module.reflectWorktimeConfirmModalVisibleState(false));
  }

  /**
   * 労働時間の確認ダイアログの提出ボタン押下
   */
  const onClickWorktimeConfirmSubmit = () => {
    dispatch(Module.reflectWorktimeConfirmModalVisibleState(false));
    submitAttendance(CONSTANTS.ATTENDANCE_PROCESS_TYPE.SUBMIT);
  }

  /**
   * 資格一覧ダイアログを表示
   * @param row 
   */
  const onClickQualification = async (row: Model.WorkRecordDetailRow) => {

    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // NowLoading表示
    dispatch(initApiResult());

    // API呼出引数
    let params: Model.getOriginalQualificationList.Request = {
      primeCompanyId: primeCompanyId,
      belongCompanyId: belongCompanyId,
      workerId: row.workerId,
      yearMonth: criteria.attendanceYearMonth,
    }
    
    // 同期でAPIを呼び出す（前に取得した値が画面に表示されないようにする）
    await dispatch(Module.getQualificationsHoldersPrimeQualificationListAsync(params));

    // 資格一覧ダイアログの表示
    dispatch(Module.reflectQualificationModalState(true));
  }

  // 検索項目の次数のチェック 正常：true
  const validateCriteriaHierarchy = (value: string): boolean => {
    if (!value) {
      // 未入力はOK
      return true;
    }

    let level = parseInt(value, 10);
    if (level < CONSTANTS.TOP_HIERARCHY_LEVEL_MIN_RANGE || level > CONSTANTS.TOP_HIERARCHY_LEVEL_MAX_RANGE) {
      return false;
    }
    return true;
  }

  /** 検索部 */
  const Criteria = () => {
    return (
      <CriteriaForm
        layout="inline"
        onFinish={searchDataList}
        initialValues={{
          "primeCertificationNo": criteria.primeCertificationNo
          , "workerLastName": criteria.workerLastName
          , "workerFirstName": criteria.workerFirstName
          , "workerLastNameKana": criteria.workerLastNameKana
          , "workerFirstNameKana": criteria.workerFirstNameKana
          , "firstPartnerCompanyName": criteria.firstPartnerCompanyName
          , "firstPartnerCompanyNameKana": criteria.firstPartnerCompanyNameKana
          , "fromTopHierarchyLevel": criteria.fromTopHierarchyLevel
          , "toTopHierarchyLevel": criteria.toTopHierarchyLevel
          , "approved": criteria.approved
          , "submitted": criteria.submitted
          , "remand": criteria.remand
          , "noSubmitted": criteria.noSubmitted
          , "hasInOutWorkTimeCheck": criteria.hasInOutWorkTimeCheck
        }}>
        <div style={{ float: "right" }}>
          <div className={styles.criteriaInputField}>
            <CriteriaForm.Item name="primeCertificationNo" id="primeCertificationNo">
              <Input
                type="text"
                placeholder="元請認定番号"
                maxLength={CONSTANTS.PRIME_CERTIFICATION_NO_MAX_LENGTH}
              />
            </CriteriaForm.Item>
            <CriteriaForm.Item name="workerLastName" id="workerLastName">
              <Input
                type="text"
                placeholder="氏名（姓）"
                maxLength={CONSTANTS.NAME_MAX_LENGTH}
              />
            </CriteriaForm.Item>
            <CriteriaForm.Item name="workerFirstName" id="workerFirstName">
              <Input
                type="text"
                placeholder="氏名（名）"
                maxLength={CONSTANTS.NAME_MAX_LENGTH}
              />
            </CriteriaForm.Item>
            <CriteriaForm.Item name="workerLastNameKana" id="workerLastNameKana">
              <Input
                type="text"
                placeholder="氏名カナ（姓）"
                maxLength={CONSTANTS.NAME_MAX_LENGTH}
              />
            </CriteriaForm.Item>
            <CriteriaForm.Item name="workerFirstNameKana" id="workerFirstNameKana">
              <Input
                type="text"
                placeholder="氏名カナ（名）"
                maxLength={CONSTANTS.NAME_MAX_LENGTH}
              />
            </CriteriaForm.Item>
            <CriteriaForm.Item name="firstPartnerCompanyName" id="firstPartnerCompanyName">
              <Input
                type="text"
                placeholder="一次協力会社名"
                maxLength={CONSTANTS.COMPANY_NAME_MAX_LENGTH}
              />
            </CriteriaForm.Item>

            <div className={styles.duration}>
              <div >
              <CriteriaForm.Item name="fromTopHierarchyLevel" id="fromTopHierarchyLevel"
                  rules={[
                    {
                      pattern: validationRules.seisu,
                      message: messagesUtils.getMessage("ERROR_TOP_HIERARCHY_LEVEL_RANGE")
                    },
                    ({ getFieldValue, validateFields }) => ({
                      validator(rule, value) {
                        if (!validateCriteriaHierarchy(value)) {
                          return Promise.reject(messagesUtils.getMessage("ERROR_TOP_HIERARCHY_LEVEL_RANGE"));
                        }

                        // From、To のチェック（To側のバリデーターでチェック）
                        if (getFieldValue("toTopHierarchyLevel") !== null) {
                          validateFields(["toTopHierarchyLevel"]);
                        }
  
                        return Promise.resolve();
                      },
                    })
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="次数（From）"
                    maxLength={CONSTANTS.TOP_HIERARCHY_LEVEL_MAX_LENGTH}
                    className={styles.topHierarchyLevelDuration}
                  />
                </CriteriaForm.Item>
                <div className={styles.durationSpan}>～</div>
                <CriteriaForm.Item name="toTopHierarchyLevel" id="toTopHierarchyLevel"
                  rules={[
                    {
                      pattern: validationRules.seisu,
                      message: messagesUtils.getMessage("ERROR_TOP_HIERARCHY_LEVEL_RANGE")
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!validateCriteriaHierarchy(value)) {
                          return Promise.reject(messagesUtils.getMessage("ERROR_TOP_HIERARCHY_LEVEL_RANGE"));
                        }

                        // From > To の場合、エラー
                        // From、Toがともに正常の場合、チェックする
                        let fromValue = getFieldValue("fromTopHierarchyLevel");
                        if (validateCriteriaHierarchy(fromValue)) {
                          let fromLevel = parseInt(fromValue, 10);
                          let toLevel = parseInt(value, 10);
                          if (fromLevel > toLevel) {
                            return Promise.reject(messagesUtils.getMessage("ERROR_FROM_TO_NUMBER_RANGE", ["次数（From）", "次数（To）"]));
                          }
                        }

                        return Promise.resolve();
                      },
                    })
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="次数（To）"
                    maxLength={CONSTANTS.TOP_HIERARCHY_LEVEL_MAX_LENGTH}
                    className={styles.topHierarchyLevelDuration}
                  />
                </CriteriaForm.Item>
              </div>
            </div>
          </div>

          <div className={styles.statusWorkTimeGrid}>
            <div className={`${styles.statusWorkTimeTopLeft} ${styles.statusWorkTimeLeft}`}>
              <span>提出-承認ステータス：</span>
            </div>
            <div className={`${styles.statusWorkTimeTopRight} ${styles.statusWorkTimeRight}`}>
              <CriteriaForm.Item name="approved" id="approved" valuePropName="checked">
                <Checkbox className={styles.checkBox}>
                  承認済
                </Checkbox>
              </CriteriaForm.Item>
              <CriteriaForm.Item name="submitted" id="submitted" valuePropName="checked">
                <Checkbox className={styles.checkBox}>
                  提出済
                </Checkbox>
              </CriteriaForm.Item>
              <CriteriaForm.Item name="noSubmitted" id="noSubmitted" valuePropName="checked">
                <Checkbox className={styles.checkBox}>
                  未提出
                </Checkbox>
              </CriteriaForm.Item>
              <CriteriaForm.Item name="remand" id="remand" valuePropName="checked">
                <Checkbox className={styles.checkBox}>
                  差戻
                </Checkbox>
              </CriteriaForm.Item>
            </div>
            <div className={`${styles.statusWorkTimeBottomLeft} ${styles.statusWorkTimeLeft}`}>
              <span>入退場/労働時間記録：</span>
            </div>
            <div className={`${styles.statusWorkTimeBottomRight} ${styles.statusWorkTimeRight}`}>
              <CriteriaForm.Item name="hasInOutWorkTimeCheck" valuePropName="checked">
                <Checkbox>
                  対象月内に入退場／労働時間記録のいずれもない作業員を除く
                </Checkbox>
              </CriteriaForm.Item>
            </div>
          </div>

          <AuthButton
            name={"検索"}
            shape={"round"}
            htmlType="submit"
          />
        </div>

      </CriteriaForm>
    )
  }

  /** メッセージ部 */
  const Message = () => {
    if (modalVisibleState || qualificationModalVisibleState) {
      return <></>
    } else {
      return <CommonMessage  searchNoDataName="作業員" />
    }
  }

  /** 一覧ヘッダー部 */
  const AttendanceDetailHeader = () => {
    let promptTextList: Array<any> = [];
    promptTextList.push(<div>・一次のみ</div>);
    promptTextList.push(<div>元請会社の設定により、二次以下の協力会社は勤怠実績の提出ができません。閲覧のみ可能です。</div>);
    promptTextList.push(<div>&nbsp;</div>);
    promptTextList.push(<div>・全次数</div>);
    promptTextList.push(<div>どの次数の協力会社も勤怠実績の閲覧・提出が可能です。</div>);

    return (
      <>
        <div style={{ whiteSpace: "nowrap" }} className={styles.searchGroup}>
          <div className={styles.flexContainer}>
            <div className={styles.headerTitle}>勤怠年月：</div>
            <div>
              <label style={{ color: "#27a69b", margin: "4px" }} onClick={(e) => onChangeMonth(-1)}><LeftSquareFilled /></label>
              {criteria.attendanceYearMonth.substring(0, 4)}年{parseInt(criteria.attendanceYearMonth.substring(4, 6))}月
              <label style={{ color: "#27a69b", margin: "4px" }} onClick={(e) => onChangeMonth(1)}><RightSquareFilled /></label>
            </div>
          </div>
          <div className={styles.flexContainer}>
            <div className={styles.headerTitle} style={{ marginLeft: "20px" }}>元請会社：</div>
            <div>{primeCompanyName}</div>
          </div>
          <div className={styles.flexContainer}>
            <div className={styles.headerTitle} style={{ marginLeft: "20px" }}>支店：</div>
            <div>{branchName}</div>
          </div>
          <div className={styles.flexContainer}>
            <div className={styles.headerTitle} style={{ marginLeft: "20px" }}>作業所：</div>
            <div>{projectName}</div>
          </div>
          <div className={styles.flexContainer}>
            <div className={styles.headerTitle} style={{ marginLeft: "20px" }}>所属会社：</div>
            <div>{belongCompanyName}</div>
          </div>
        </div>
        <div style={{ whiteSpace: "nowrap", paddingBottom: "10px" }} className={styles.searchGroup}>
          <div className={styles.headerTitle} style={{ marginLeft: "20px" }}>提出権限：</div>
          <div>
            {isSubmitLevelOnlyFirst(primeCompanyId) ? "一次のみ" : "全次数"}
            <Tooltip
              placement="topLeft"
              title={promptTextList}
              overlayStyle={{ maxWidth: '1000px' }}>
              <span>&nbsp;
                <QuestionCircleFilled />&nbsp;
              </span>
            </Tooltip>
          </div>
        </div>
      </>
    )
  }

  /** ボタン部 */
  const AttendanceButton = () => {
    return (
      <FooterButtonArea>
        <AuthButton
          name={"戻る"}
          size={"large"}
          shape={"round"}
          onClick={onClickBack}
          className={AuthButtonStyles.backButtonFixed}
          style={{ margin: "10px" }}
        />

        <AuthButton
          name={"提出"}
          authorities={[
            AuthButtonAuthorities.partnerAttendanceSubmitAuth,
          ]}
          size={"large"}
          shape={"round"}
          onClick={() => onClickProcess(CONSTANTS.ATTENDANCE_PROCESS_TYPE.SUBMIT)}
          className={AuthButtonStyles.partnerAuthButtonFixed}
          disabled={editAvailableFlag === CONSTANTS.EDIT_AVAILABLE_FLAG_NOT_AVAILABLE ? true : existSubmittedChecked ? true : existNotSubmittedChecked ? false : true}
          style={{
            display: `${canSubmitLoginCompany() ? "" : "none"}`,
            margin: "10px",
          }}
        />

        <AuthButton
          name={"提出取消"}
          authorities={[
            AuthButtonAuthorities.partnerAttendanceSubmitAuth,
          ]}
          size={"large"}
          shape={"round"}
          onClick={() => onClickProcess(CONSTANTS.ATTENDANCE_PROCESS_TYPE.SUBMIT_CANCEL)}
          className={AuthButtonStyles.partnerAuthButtonFixed}
          disabled={editAvailableFlag === CONSTANTS.EDIT_AVAILABLE_FLAG_NOT_AVAILABLE ? true : existNotSubmittedChecked ? true : existSubmittedChecked ? false : true}
          style={{ 
            display: `${canSubmitLoginCompany() ? "" : "none"}`,
            margin: "10px",
          }}
        />
      </FooterButtonArea>
    );
  }

  /** 資格一覧ダイアログ表示内容 */
  const QualificationModalContent = () => {
    // ダイアログ表示時の資格一覧取得API実行後、APIエラーメッセージが設定されているかどうか
    let isApiSuccess: boolean = CONSTANTS.API_STATUS_INITIAL !== apiResult.status && "" === apiResult.errorCode;
    if (isApiSuccess) {
      // API正常終了 
      return (
        <div className={styles.contentArea} >
          {criteria.attendanceYearMonth.substring(0, 4)}年{parseInt(criteria.attendanceYearMonth.substring(4, 6))}月時点で保持している資格一覧

          {qualificationList.length > 0 ?
            <Content
              style={{ margin: "auto", textAlign: "left" }}
              hasapicall={"false"}>
              <Table
                columns={qualificationDialogColumns}
                size='small'
                dataSource={qualificationList}
                pagination={false}
                className="hoverNotBackground"
                style={{ marginLeft: "20px" }}
                bordered
              />
            </Content> : <div className={styles.qualificationModalMessage}><ExclamationCircleOutlined className={styles.iconSize} style={{ marginRight: "6px" }} />保有資格はありません</div>
          }
        </div>
      );
    } else {
      // APIエラー有
      return (
        <div className={styles.contentArea} >
          {criteria.attendanceYearMonth.substring(0, 4)}年{parseInt(criteria.attendanceYearMonth.substring(4, 6))}月時点で保持している資格一覧
          <CommonMessage isModal={true} />
        </div>
      );  
    }
  }

  /** 確認ダイアログの文言 */
  const WorktimeConfirmText = () => {
    return (
      <>
        { worktimeConfirmText }
        { worktimeConfirmTextWorker.map((worker, i) => {
          return (
          <>
            　{ worker }：<span className={styles.worktimeConfirmTextDate}>{worktimeConfirmTextDate[i]}</span>
            { // 作業員ごとに改行する
              i < worktimeConfirmTextWorker.length - 1
              ? 
              <br />
              :
              <></>
            }
          </>
          )
        })}
      </>
    )
  }

  /** ツールチップの注意文言 */
  const AnotationTooltipText = () => {
    return (
      <>
        <div>【入退場履歴】</div>
        <div>・入退場時間が赤文字で表示：退場時間が入場時間より早い時間となっています。</div>
        <div>【労働時間】</div>
        {isCalcWorkTime(primeCompanyId)
        ? // 自動入力ありの場合
        <>
          <div>・時間入力あり：入退場時間をもとに労働時間が自動入力されています（どちらか一方の場合は８時間）。</div>
        </>
        : // 自動入力なしの場合
        <>
          <div>・時間入力あり：入退場時間をもとに労働時間が自動入力されています。どちらか一方のみ、または記録なしは自動入力対象外です。</div>
        </>}
        {isEditableWorkTime(primeCompanyId)
        ? // 編集可の場合
        <>
          <div>・時間入力なし：入退場時間がないため、労働時間がある場合は入力が必要です。</div>
          <div>※ 欄をクリックすることで編集画面が表示されるので、任意の時間を入力可能です。</div>
        </>
        : // 編集不可の場合
        <>
          <div>・時間入力なし：入退場時間がないため、労働時間の入力が行われていません。</div>
          <div>※ 元請会社様のルールで労働時間の任意入力は禁止されています。</div>
        </>}
      </>
    )
  }

  /**
   * 編集禁止のアラートを×ボタンで閉じたときの処理
   */
  const closeNotEditableAlert = () => {
    const params = {
      primeCompanyId: primeCompanyId
      , hiddenAlertIdx: CONSTANTS.HIDDEN_ALERT.NotEditable
    };
    // セッションのユーザ情報のアラート非表示元請企業IDリストに追加する
    dispatch(putLoginUserInfoAlertAsync(params, loginUserInfo));
  }

  // データ連携同意モーダル非表示アクション
  const hideSubmitModalDisagree = () => {
    // モーダル非表示
    dispatch(Module.reflectSubmitModalDisagreeVisibleState(false));
  }

  // 「建設サイト・シリーズ」サービス利用約款URL取得
  const getServiceTermURL = () => {
    const host = window.location.host;
    // フロント側のドメインに合わせた約款画面のURLを特定
    let baseURL;
    if (host === 't2.skillmap-site.kensetsu-site.com') {
      baseURL = CONSTANTS.URL_KENSETSU_SITE_SERVICE_TERM_FOR_T5;
    } else if (host === 's2.skillmap-site.kensetsu-site.com') {
      baseURL = CONSTANTS.URL_KENSETSU_SITE_SERVICE_TERM_FOR_S2;
    } else {
      baseURL = CONSTANTS.URL_KENSETSU_SITE_SERVICE_TERM_FOR_P2;
    }
    return baseURL;
  }

  // 「建設サイト・シリーズ」サービス利用約款を別タブで開く
  const openServiceTermAnotherTab = () => {
    window.open(getServiceTermURL());
  }

  /**
   * 対象プロジェクト一覧の整形
   * @param text 
   * @param row 
   * @returns 
   */
  const renderProjectName = (text: string, row: Model.QualificationRow) => {

    let projectNames: Array<any> = [];
    let promptTextList: Array<any> = [];
    const projectNameList: string[] = text.split(",");

    let index = 0;
    projectNameList.sort((a,b) => {
      return a > b ? 1 : -1
    }).forEach(projectName => {
      if (projectNameList.length >= 4 && index === 2) {
        // 対象プロジェクトが4件以上ある場合、3件目以降は「...」で表示する（...の行を含めてMAX3行）
        projectNames.push(<div className={styles.columnAlignLeft}>...</div>);
      } else if (projectNameList.length < 4 || index < 3) {
        // 15文字より多い場合、15文字目以降は「...」で表示する（...を含めてMAX15文字）
        projectNames.push(
          <div className={styles.columnAlignLeft}>{projectName.length > 15 ? projectName.substring(0,14) + "..." : projectName}</div>
        );
      }

      // Tooltipに表示するメッセージの作成
      promptTextList.push(<div>{projectName}</div>);
      index++;
    });

    if (text.length >= 1) {
      return (<Tooltip placement="left" title={promptTextList}><div>{projectNames}</div></Tooltip>)
    } else {
      return <div className={styles.columnAlignLeft}>{row.certificationProjectFlag === "1" ? "なし" : "すべてのプロジェクト"}</div>
    }
  };

  return (

    <Layout>
      <Header />
      <Content>
        <FunctionTitle title={props.title} />
        {
          isDisplayNotEditable(primeCompanyId) ?
          <Alert
            message="元請会社様のルールで労働時間の任意入力は禁止されています。"
            type='warning'
            showIcon
            closable
            style={{
              width: "fit-content"
              , marginTop: "40px"
              , marginBottom :"15px"
              , fontWeight: "bold"
              , boxShadow: "0 4px 4px rgba(0,0,0,20%)"
            }}
            onClose={closeNotEditableAlert}
          />
          : <></>
        }
        {
          dataList.some((data: Model.WorkRecordDetailRow) => {
            return data.ccusErrorFlag === CONSTANTS.CCUS_ERROR_FLAG.ON;
          }) ?
          <Alert
            message={
              <>
                <b>{messagesUtils.getMessage("ERROR_GET_CCUS_INFO_TITLE")}</b>
                <br />{messagesUtils.getMessage("ERROR_GET_CCUS_INFO_TEXT_PARTNER")}
              </>
            }
            type='warning'
            showIcon
            closable
            style={{
              width: "fit-content"
              , marginTop: isDisplayNotEditable(primeCompanyId) ? "10px" : "40px"
              , marginBottom :"15px"
              , boxShadow: "0 4px 4px rgba(0,0,0,20%)"
              , textAlign: "left"
            }}
          />
          : <></>
        }
        <Criteria />
        <Message />
        <div style={{ textAlign: "left", fontSize: "25px", color: "red" }}>
          {isContainInvalidInOutTime ? "入場時間より退場時間が早い作業日があるため、通門設定に問題がないかを元請会社様にお問い合わせください。": ""}
        </div>
        <AttendanceDetailHeader />
        {0 < total && 0 < dataList.length ?
          <>
            {editAvailableFlag === CONSTANTS.EDIT_AVAILABLE_FLAG_NOT_AVAILABLE && !existNotSubmitted && dataList.length > 0 ?
              <>
                <div style={{ float: "left" }}>提出済の勤怠情報の操作が必要な場合は、対象となる勤怠情報を提出した元請会社のご担当者にご連絡ください。</div>
                <br />
              </>
              : <></>}
            <div style={{ display: "flex", justifyContent: "space-between"}}>
              <div style={{textAlign: "left" }}>
                <div>・グリーンサイト通門管理機能上で入退場情報登録を申請した場合、元請会社が承認してからスキルマップサイトにデータが反映されるまで、しばらく時間かかることがあります。</div>
                <div>・「一次協力会社」の下で異なる複数の編成（次数）に入っている場合、「作業次数」にはもっとも上位の次数が表示されます。</div>
              </div>
              <div style={{textAlign: "right" }}>
                <div><span className={styles.explainGray}>　　　</span>...該当の日付において資格条件に合致せず、認定対象外となる勤怠です。</div>
                <div>
                  入退場履歴／労働時間欄の表示・入力について
                  <Tooltip
                    placement="topLeft"
                    title={AnotationTooltipText}
                    overlayStyle={{maxWidth: '1000px'}}>
                    <span>&nbsp;
                      <QuestionCircleFilled />&nbsp;
                    </span>
                  </Tooltip>
                </div>
              </div>
            </div>
            <div className={"topPagination"} style={{ marginTop: "10px" }}>
              <Pagination
                className={"commonPagination topLeftPagination partnerPagination"}
                defaultPageSize={10}
                pageSize={criteria.limit}
                pageSizeOptions={["5", "10", "20"]}
                showSizeChanger={true}
                showTotal={() => (<span>１ページあたりの表示件数</span>)}
                locale={{ items_per_page: "件/ページ" }}
                onChange={handlePaginationChange}
                onShowSizeChange={(page, size) => {
                  handlePaginationChange(page, size); // ページサイズ変更時に1ページ目へ戻す
                }}
              />
              <Pagination
                className={"commonPagination topRightPagination partnerPagination"}
                total={total}
                current={criteria.offset / criteria.limit + 1}
                pageSize={criteria.limit}
                showTotal={(total) => <><span>{total.toLocaleString()}</span> 件数中、<span>{(criteria.offset + 1).toLocaleString()}</span> － <span>{total <= criteria.offset + criteria.limit ? total.toLocaleString() : (criteria.offset + criteria.limit).toLocaleString()}</span> 件</>}
                onChange={handlePaginationChange}
              />
            </div>
            <Table
              size="small"
              className="hoverNotBackground"
              columns={columns}
              sticky={{ offsetHeader : -31 }}
              dataSource={dataList}
              pagination={false}
            >
            </Table>
            <Pagination
              className={"commonPagination bottomPagination partnerPagination"}
              total={total}
              current={criteria.offset / criteria.limit + 1}
              pageSize={criteria.limit}
              onChange={handlePaginationChange}
            />
          </>
          : <></>
        }
        <MergeCompanyAnnotations
          attendanceList={dataList}
          mergeCompanyAttendanceFlgName={"abolishCompanyFlag"}
        />
      </Content>
      <AttendanceButton />
      <Footer />

      <Modal
        visible={modalVisibleState}
        footer={[
          <AuthButton
            name={"キャンセル"}
            size={"large"}
            shape={"round"}
            onClick={onClickCancel}
            className={AuthButtonStyles.backButtonFixed}
            style={{ margin: "10px" }}
          />,
          <AuthButton
            name={"確定"}
            size={"large"}
            shape={"round"}
            onClick={onClickDecision}
            className={AuthButtonStyles.partnerAuthButtonFixed}
            loading={isLoading}
            style={{ margin: "10px" }} />
        ]}
        destroyOnClose
        closable={false}
        width={350}>
        <Layout>
          <CommonMessage isModal={true} />
          <Content
            style={{ margin: "auto", textAlign: "right" }}
            hasapicall={"false"}>
            <Form
              form={form}
              initialValues={{
                "workingTime": info.dailyWorkStatus.workingTime
              }}
            >
              <Form.Item label="日付">
                {formatUtils.formatDateToYearsAndDayWeek(info.dailyWorkStatus.date)}
              </Form.Item>
              <Form.Item label="入場時間">
                {formatUtils.formatDateToTime(info.dailyWorkStatus.firstInTime)}
              </Form.Item>
              <Form.Item label="退場時間">
                {formatUtils.formatDateToTime(info.dailyWorkStatus.lastOutTime)}
              </Form.Item>
              <Form.Item name="workingTime" label="労働時間" className={styles.workingTimeForm}
                rules={[
                  {
                    pattern: validationRules.worktime,
                    message: (
                      <span className={styles.workingTimeError}>
                        {messagesUtils.getMessage("ERROR_INPUT_HALF_WIDTH_DIGIT")}
                      </span>
                    )
                  }
                ]}
              >
                <Input
                  type="text"
                  onBlur={(e) => onBlurWorkingTime(e.target.value)}
                  onKeyPress={((e) => {
                    if (e.key === "Enter") {
                      onPressEnter();
                      e.preventDefault()
                    }
                  })}
                  style={{ width: "100px", textAlign: "right" }}
                  maxLength={CONSTANTS.WORKING_TIME_MAX_LENGTH}
                />
              </Form.Item>
            </Form>
          </Content>
        </Layout>
      </Modal>

      {/* 資格一覧ダイアログ */}
      <Modal
        visible={qualificationModalVisibleState}
        footer={[
          <AuthButton
            name={"閉じる"}
            size={"large"}
            shape={"round"}
            onClick={onClickQualificationCancel}
            className={AuthButtonStyles.backButtonFixed}
            style={{ margin: "10px" }}
          />,
        ]}
        destroyOnClose
        closable={false}
        width={900}
        >
        <Layout>
          <QualificationModalContent />
        </Layout>
      </Modal>

      <Modal
        visible={worktimeConfirmModalVisibleState}
        footer={[
          <AuthButton
            name={"労働時間の修正に戻る"}
            size={"large"}
            shape={"round"}
            onClick={onClickWorktimeConfirmCancel}
            className={AuthButtonStyles.backButtonFixed}
            style={{ margin: "10px" }}
          />,
          <AuthButton
            name={"このまま提出する"}
            size={"large"}
            shape={"round"}
            onClick={onClickWorktimeConfirmSubmit}
            className={AuthButtonStyles.partnerAuthButtonFixed}
            style={{ margin: "10px" }} />
        ]}
        destroyOnClose
        closable={false}
        width={"90%"}>
        <Layout>
          <Content
            style={{
              margin: "auto",
              whiteSpace: "pre-wrap",
              fontSize: "30px",
            }}>
            <WorktimeConfirmText />
          </Content>
        </Layout>
      </Modal>

      {/* データ連携同意ダイアログ */}
      <Modal
        visible={submitModalDisagreeVisibleState}
        footer={
          // 企業担当者かつ自社の場合同意ボタン表示
          isCompanyStaff() && isLoginUserBelongCompanyEqualDisplayBelongCompany()
          ? 
          <>
            <AuthButton
              name={"戻る"}
              size={"large"}
              shape={"round"}
              onClick={hideSubmitModalDisagree}
              className={AuthButtonStyles.backButtonFixed}
              style={{ margin: "10px" }}
            />
            <AuthButton
              name={"約款の同意"}
              size={"large"}
              shape={"round"}
              onClick={openServiceTermAnotherTab}
              className={AuthButtonStyles.partnerAuthButtonFixed}
              style={{ margin: "10px" }}
            />
          </>
          :
          <AuthButton
            name={"閉じる"}
            size={"large"}
            shape={"round"}
            onClick={hideSubmitModalDisagree}
            className={AuthButtonStyles.partnerAuthButtonFixed}
            style={{ margin: "10px" }}
          />
        }
        destroyOnClose
        closable={false}
        width={900}
      >
        <Layout>
          <Content
            style={{ margin: "auto", textAlign: "center", fontSize: "16px", lineHeight: "2" }}
            hasapicall={"false"}>
            {
              // 自社の企業担当者である場合
              isCompanyStaff() && isLoginUserBelongCompanyEqualDisplayBelongCompany()
              ?
              <>
                <div style={{ fontSize: "18px", fontWeight: "bold", margin: "15px" }}>建退共電子申請専用サイトへの送信には約款への同意が必要です</div>
                <div style={{ textAlign: "left" }}>
                  <div>対象技能者の個人情報を含む就労実績を建退共電子申請専用サイトへ送信します。</div>
                  <div>本機能を利用して就労実績を送信するには<a href={getServiceTermURL()} target="_blank">「建設サイト・シリーズ」サービス利用約款</a>への同意が必要です。以下のボタンから「建設サイト・シリーズ」ポータルサイトへ移動し、約款の確認および同意を行ってください。</div>
                </div>
              </>
              // 自社ではあるが企業担当者でない場合
              :
              isLoginUserBelongCompanyEqualDisplayBelongCompany()
              ?
              <>
                <div style={{ fontSize: "18px", fontWeight: "bold", margin: "15px" }}>「企業担当者」に約款への同意をご依頼ください</div>
                <div style={{ textAlign: "left" }}>
                  <div>勤怠の提出対象となっている技能者に、元請会社が建退共電子申請専用サイトへ就労実績を送信する対象者が含まれています。勤怠を提出するには、「建設サイト・シリーズ」サービス利用約款への同意が必要です。約款への同意は、「企業担当者」権限を持つユーザーのみ行えます。</div>
                  <div>お手数ですが、貴社の「企業担当者」権限を持つユーザーに同意手続きをご依頼ください。手続きが完了すると、勤怠を提出できるようになります。</div>
                </div>
              </>
              // 自社でない場合
              : 
              <>
                <div style={{ fontSize: "18px", fontWeight: "bold", margin: "15px" }}>「{belongCompanyName}」に約款への同意をご依頼ください</div>
                <div style={{ textAlign: "left" }}>
                  <div>勤怠の提出対象となっている技能者に、元請会社が建退共電子申請専用サイトへ就労実績を送信する対象者が含まれています。勤怠を提出するには、対象技能者の所属企業である「{belongCompanyName}」側で「建設サイト・シリーズ」サービス利用約款に同意済である必要があります。</div>
                  <div>お手数ですが、「{belongCompanyName}」に同意手続きをご依頼ください。同社での手続きが完了すると、勤怠の提出をできるようになります。</div>
                </div>
              </>
            }
          </Content>
        </Layout>
      </Modal>
    </Layout>
  );
}


